import type { WorkflowSource } from '@/api/types';

// THE one place the three workflow sources are worded and coloured — the list cards, the detail header and the
// diagram all read it, so a workflow never shows one source on the card and another on the diagram.

export interface WorkflowSourceView {
  label: string;
  tone: 'ink' | 'violet' | 'green' | 'amber' | 'slate';
  explain: string;
}

export function workflowSourceView(source: WorkflowSource | string | null | undefined): WorkflowSourceView {
  switch (source) {
    case 'code_first':
      return {
        label: 'Defined in code',
        tone: 'green',
        explain: 'These are the steps that run. They ship with the application, so a change goes out with a deploy.',
      };
    case 'global_override':
      return {
        label: 'Global override',
        tone: 'amber',
        explain: 'A database row replaces the coded steps for every practice that has no override of its own.',
      };
    case 'merchant_override':
      return {
        label: 'Practice override',
        tone: 'violet',
        explain: 'This practice has its own steps in the database, replacing the default.',
      };
    default:
      return { label: 'Unknown source', tone: 'slate', explain: 'The source of these steps could not be determined.' };
  }
}

/** Card / detail tone for a step from its executor category ([WorkflowExecutorDoc].Category). */
export function stepTone(category: string | null | undefined, isAgent: boolean): 'ink' | 'violet' | 'green' | 'amber' | 'red' {
  if (isAgent || category === 'Agent') return 'violet';
  switch (category) {
    case 'Persistence':
      return 'green';
    case 'Notify':
      return 'amber';
    case 'Conditional':
      return 'red';
    default:
      return 'ink';
  }
}

/** Where a workflow's detail page lives: by row id when a row exists, else by name. */
export function workflowHref(w: { id: number | null; name: string }): string {
  return w.id ? `/workflows/${w.id}` : `/workflows/${encodeURIComponent(w.name)}`;
}
